import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import styles from './Hero.module.css';

const WORDS = ['Websites', 'Apps', 'Games', 'Stuff'];

const RotatingWords: React.FC = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % WORDS.length);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  const word = WORDS[index];

  return (
    <span className={styles.rotatingWords} aria-live="polite">
      <span className={styles.rotatingWordsClip}>
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={word}
            className={styles.rotatingWord}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -24 }}
            transition={{ duration: 0.45, ease: [0.4, 0, 0.2, 1] }}
          >
            {word}
          </motion.span>
        </AnimatePresence>
      </span>
    </span>
  );
};

export default RotatingWords;
